import { render, staticRenderFns } from "./facets-settings-list.component.vue?vue&type=template&id=39d315e6&scoped=true"
import script from "./facets-settings-list.component.vue?vue&type=script&lang=ts"
export * from "./facets-settings-list.component.vue?vue&type=script&lang=ts"
import style0 from "./facets-settings-list.component.vue?vue&type=style&index=0&id=39d315e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d315e6",
  null
  
)

export default component.exports